<template>
  <article class="Post-Infonoise" @mouseenter="handleHover" ref="postElement">
    <DotUnread v-if="get_post.is_new"/>
    <div class="Post-Infonoise__icon">
      <img class="Post-Infonoise__gif" :src="get_Gif" width="36px" height="36px" v-if="get_Gif" />
      <AvatarImage class="Post-Infonoise__main-img" :src="get_iconSrc" v-if="get_iconSrc" :size="28" :lazyLoad="true" />
      <time class="Post-Infonoise__time">{{ get_date }}</time>
    </div>
    <a class="Post-Infonoise__ttl" :href="get_postUrl" target="_self" @click="handleClick" v-html="get_title"></a>
    <SignalsList class="Post-Infonoise__signals" :signals="get_post?.coin_prices" v-if="get_post?.coin_prices?.length > 0" />
    <CommentLast
      class="Post-Infonoise__comment"
      :count="get_commentCount"
      :postId="props.postId"
      :basicView="props.basicView"
      v-if="get_lastComment"
    />
     <SliderThumbnails class="Post-Infonoise__images" :data="Object.values(get_post.images_list)" v-if="get_hasImages"/>
  </article>
</template>

<script setup>
import {formatTime_h_min, formatTime_dn_mn} from '@shared/utils/time/formated.js';
import { computed, nextTick, ref, onMounted, onBeforeUnmount } from 'vue';
import {useRoute} from 'vue-router';
import {useStore} from 'vuex';
import {Props} from './scripts/props.js';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
import { observeOnce, unobserve } from '@shared/services/observers/intersectionObservers.js';
//------------------------------------
import CommentLast from '@entities/Comments/CommentLast/CommentLast.vue';
import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
import SliderThumbnails from '@/Groups/Slider/public/modules/SliderThumbnails/SliderThumbnails.vue';
import SignalsList from './components/SignalsList/SignalsList.vue';
import DotUnread from "@entities/Posts/Components/DotUnread/DotUnread.vue";
//------------------------------------
const store = useStore();
const route = useRoute();
const props = defineProps(Props());
//------------------------------------
const postElement = ref(null);
//------------------------------------
const FIRE_GIF = require('./components/gif/fire.gif');
const LIGHT_GIF = require('./components/gif/star.gif');
const DINAMIT_GIF = require('./components/gif/bomb.gif');
const GEM_GIF = require('./components/gif/gem.gif');
const ROCKET_GIF = require('./components/gif/rocket.gif');
const WINNER_GIF = require('./components/gif/winner.gif');
//------------------------------------
let hoverTimer = null;
let visibilityTimer = null;
//------------------------------------
onMounted(() => {
  if (!postElement.value || !get_post.value.is_new) return;
  const rect = postElement.value.getBoundingClientRect();
  const isVisible = (
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.bottom >= 0
  );
  if (isVisible) {
    handleVisibility();
  } else {
    observeOnce(postElement.value, handleVisibility);
  }
});
onBeforeUnmount(() => {
  if (postElement.value) {
    unobserve(postElement.value);
    postElement.value.removeEventListener('mouseenter', handleHover);
  }
  clearTimeout(visibilityTimer);
  clearTimeout(hoverTimer);
});
//------------------------------------
//Получить пост
const get_post = computed(() => store.state.ContentSystem.Infonoise.list[props.postId]);
//Получить иконку изображения
const get_iconSrc = computed(() => get_post.value.news_atributes.label);
//Получить URL поста
const get_postUrl = computed(() => `/${get_post.value.model_name.toLowerCase()}/${get_post.value.id}`);
//Получить отформатированное время
const get_date = computed(() => {
  return props.isDate ? formatTime_dn_mn(get_post.value.publication_date) :
    formatTime_h_min(get_post.value.publication_date);
});
//Получить заголовок
const get_title = computed(() => get_post.value.rich_title || get_post.value.title)
//Содержит ли пост изображения
const get_hasImages = computed(() => Object.keys(get_post.value.images_list).length > 0);
//Получить кол-во комментариев к посту
const get_commentCount = computed(() => get_post.value.comments_count);
//Получить объект последнего комментария
const get_lastComment = computed(() => get_post.value.last_comment);
//Получить гифку для иконки, если она есть
const get_Gif = computed(() => {
  const gifName = get_post.value.gif_for_main_page;
  if(gifName === 'fire') return FIRE_GIF;
  else if(gifName === 'lightning') return LIGHT_GIF;
  else if(gifName === 'dinamit') return DINAMIT_GIF;
  else if(gifName === 'gem') return GEM_GIF;
  else if(gifName === 'rocket') return ROCKET_GIF;
  else if(gifName === 'winner') return WINNER_GIF;
  else return null
})
//------------------------------------
//Открыть попап с контентом, изменить адрес без перехода на страницу
const toOpenContentPopup = async () => {
  store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
  await nextTick();
  toChangeUrl();
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
};
// Обработчик клика по заголовку
const handleClick = (event) => {
  const isMobile = window.innerWidth <= 768;
  const isTooltipTarget = event.target.closest('.title-tooltip-coin') || event.target.closest('.Coin-Info-Tooltip');
  // Если на мобилке и клик был по тултипу, не открываем пост
  if (isMobile && isTooltipTarget) {
    event.preventDefault();
    return;
  }
  // Если клик с Ctrl, Meta, Shift или колесиком — открыть в новой вкладке
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
    return;
  }
  event.preventDefault();
  toOpenContentPopup();
};
//Обновить адрес в строке поиска и запомнить последний урл перед переходом
const toChangeUrl = () => {
  store.commit('ContentSystem/toRememberLastPageUrl', route.path)
  const url = `/${get_post.value.model_name.toLowerCase()}/${get_post.value.id}`;
  window.history.replaceState({}, '', url);
};

  const handleHover = () => {
    if(!get_post.value.is_new)return;
    removeNewPostFlag();
    clearTimeout(visibilityTimer);
    if (postElement.value) {
      unobserve(postElement.value);
    }
  };
  const handleVisibility = () => {
    if(!get_post.value.is_new)return;
    visibilityTimer = setTimeout(() => {
      removeNewPostFlag();
      unobserve(postElement.value);
    }, 5000);
  };
  //Отмечаем, что пост прочитан
  const removeNewPostFlag = () => {
    store.commit('ContentSystem/Infonoise/toUpdateNewStatus', props.postId)
  }
</script>

<style lang="scss">
@import './styles/_conf';
</style>
